import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';

import { IconButtonComponent, IconComponent } from '@mode/capra';
import { SharedUiModule } from '@mode/shared/ui';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { HelpMenuComponent } from './help-menu/help-menu.component';
import { IntercomDirective } from './intercom/intercom.directive';
import { PromoPopoverComponent } from './promo-popover/promo-popover.component';

@NgModule({
  imports: [CommonModule, MatLegacyMenuModule, SharedUiModule, SharedUtilDomModule, IconButtonComponent, IconComponent],
  declarations: [HelpMenuComponent, IntercomDirective, PromoPopoverComponent],
  exports: [HelpMenuComponent, PromoPopoverComponent],
})
export class AccountsUiModule {}
